export default __webpack_public_path__ + "static/media/basketballBanner.61c875ac.jpg";